import Layout from "@/components/Layout";

// Converted from video.php by scripts/convert-php-pages.mjs.
export default function PageVideo() {
  return (
    <Layout route="/video">
      <>
<section>
<div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
<div className="carousel-inner">
<div className="carousel-item active">
<img src="/assets/img/videpbanner.jpg" className="d-block w-100" alt="..." />
</div>
<div className="carousel-item">
<img src="/assets/img/videpbanner.jpg" className="d-block w-100" alt="..." />
</div>
<div className="carousel-item">
<img src="/assets/img/videpbanner.jpg" className="d-block w-100" alt="..." />
</div>
</div>
</div>
</section>
<section style={{ boxShadow: "1px 4px 23px 0px" }}>
<div className="container">
<div className="row">
<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 col-lg-offset-2">
<div className="service_heading_wraper_3 text-center med_bottompadder70_3 wow fadeInDown" data-wow-delay="0.5s" style={{ visibility: "visible", animationDelay: "0.5s", animationName: "fadeInDown" }}>
<h1 style={{ paddingTop: "20px", paddingBottom: "20px" }}>Patient Education</h1>


<p>
                            Dr. Parveen Yadav, a leading Minimal Invasive and Robotic Thoracic Onco Surgeon at Chest Surgery India, combines surgical excellence with patient education. He enlightens patients about cancer types, treatments, and prevention through informative videos. Dr. Yadav goes beyond showcasing advanced surgical machines demystifying procedures and instilling confidence.
                        </p>
<p>
                            Chest Surgery India, the hospital he's associated with, is renowned for cutting-edge facilities and patient-centric care. Dr. Yadav's commitment to advanced surgery and patient empowerment makes him a standout healthcare professional. In his care, patients experience top-notch surgical expertise and gain valuable insights into their medical journey.
                        </p>
</div>
</div>
<div className="col-lg-8 col-md-8 col-sm-12" style={{ paddingBottom: "30px" }}>

<div className="youtube-video" data-video-id="PGNxJHj2cLY" data-height="520">
<div className="thumbnail">
<img src="https://img.youtube.com/vi/PGNxJHj2cLY/hqdefault.jpg" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>
</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="391pHTWc_uE" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img src="https://img.youtube.com/vi/391pHTWc_uE/hqdefault.jpg" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

<div className="youtube-container" data-video-id="e7YXXCmJsnM" data-height="244">
<div className="thumbnail">
<img src="https://img.youtube.com/vi/e7YXXCmJsnM/hqdefault.jpg" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="e7YXXCmJsnM" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img src="https://img.youtube.com/vi/e7YXXCmJsnM/hqdefault.jpg" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="PTwWMOweu98" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img src="https://img.youtube.com/vi/PTwWMOweu98/hqdefault.jpg" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="e7YXXCmJsnM" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img src="https://img.youtube.com/vi/e7YXXCmJsnM/hqdefault.jpg" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="PTwWMOweu98" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img src="https://img.youtube.com/vi/PTwWMOweu98/hqdefault.jpg" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="e7YXXCmJsnM" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img src="https://img.youtube.com/vi/e7YXXCmJsnM/hqdefault.jpg" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="PTwWMOweu98" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img src="https://img.youtube.com/vi/PTwWMOweu98/hqdefault.jpg" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="KVXCmyQcros" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img src="https://img.youtube.com/vi/KVXCmyQcros/hqdefault.jpg" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="5WRncS7O70A" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img src="https://img.youtube.com/vi/5WRncS7O70A/hqdefault.jpg" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="nwkRMmAV1YY" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img src="https://img.youtube.com/vi/nwkRMmAV1YY/hqdefault.jpg" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="JbKBp8vC1lY" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img src="https://img.youtube.com/vi/JbKBp8vC1lY/hqdefault.jpg" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="FqVV0b8QHeY" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img src="https://img.youtube.com/vi/FqVV0b8QHeY/hqdefault.jpg" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="youtube-container" data-video-id="EegO6lDSK8s" data-height="244" style={{ marginBottom: "30px" }}>
<div className="thumbnail">
<img src="https://img.youtube.com/vi/EegO6lDSK8s/hqdefault.jpg" alt="Video Thumbnail" />
<div className="play-button">
<i className="fa fa-youtube-play"></i>
</div>
</div>
</div>

</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="column people">
<div className="content">
<img src="/assets/img/videoimg.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="column people">
<div className="content">
<img src="/assets/img/videoimg1.jpg.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="column people">
<div className="content">
<img src="/assets/img/videoimg2.jpg.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
</div>
<div className="col-lg-4 col-md-4 col-sm-12" style={{ paddingBottom: "30px" }}>
<div className="column people">
<div className="content">
<img src="/assets/img/videoimg3.jpg.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
</div>
</div>
</div>
</section>


      </>
    </Layout>
  );
}
